var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row mt-3 list-row" },
    [
      _c("plain-text-control", {
        class: ["col-xs-12 col-sm-5 col-form-label", _vm.bold ? "bold" : ""],
        attrs: { title: _vm.title, id: _vm.title }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-sm-7 form-row-content" }, [
        _vm.ordered
          ? _c(
              "ol",
              { attrs: { "aria-labelledby": _vm.title } },
              _vm._l(_vm.contents, function(item, index) {
                return _c(
                  "li",
                  { staticStyle: { "white-space": "pre-wrap" } },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            )
          : _c(
              "ul",
              { attrs: { "aria-labelledby": _vm.title } },
              _vm._l(_vm.contents, function(item, index) {
                return _c(
                  "li",
                  { staticStyle: { "white-space": "pre-wrap" } },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }